export default {
  install(Vue) {
    Vue.prototype.$makeToast = function (message = '', variant = 'info', title = '', error = undefined) {
      if (error != undefined) {
        if (error.response != null && (error.response.status == 401 || error.response.status == 403)) return;  // Prevent message be raised.
        message = error.Error ? error.Error + " [Code: " + error.ErrorCode + "]." : error.message;
      }

      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        toaster: "b-toaster-top-center",
        solid: true,
        appendToast: true
      });
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/toast.js